module.exports = __webpack_public_path__ + "img/img_information_security_2.172db34.png";